const digest = 'fec39f64c26d7b3e452ade23274e777499483d023221f8fb74eeaaf1a11124ef';
const css = `@media (min-width:1024px){._rowHeight_2gvv5_2{height:64px}}@media (min-width:800px) and (max-width:1023px){._rowHeight_2gvv5_2{height:108px}}@media (min-width:568px) and (max-width:799px){._rowHeight_2gvv5_2{height:152px}}@media (max-width:567px){._rowHeight_2gvv5_2{height:196px}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'rowHeight': '_rowHeight_2gvv5_2' };
export const rowHeight = '_rowHeight_2gvv5_2';
export { css, digest };